// This is an auto-generated file. Do not edit.
export const VERSION = '@civic/icp-gateway-react:0.0.10';
